import React from 'react';
import { InteractiveBranding } from '../components/Contact/InteractiveBranding';
import { ContactForm } from '../components/Contact/ContactForm';

export const ContactPage: React.FC = () => {
    return (
        <div className="flex flex-col lg:flex-row w-full min-h-screen">
            {/* Left Column: Interactive Physics Canvas - White Background */}
            <div className="w-full lg:w-1/2 relative order-2 lg:order-1 bg-white min-h-screen">
                <InteractiveBranding />
            </div>

            {/* Right Column: Contact Form - Dark Background #293039 */}
            <div className="w-full lg:w-1/2 bg-[#293039] order-1 lg:order-2 min-h-screen">
                <ContactForm />
            </div>
        </div>
    );
};
